import * as React from 'react';
import clsx from 'clsx';
import { useTranslator } from '@gandi/translate';
import { isNode } from '../../../dom';
import { Base } from '../../Base';
import { SrOnly } from '../../Helper';
import Svg from '../../Svg';
import InputAddon from '../InputAddon';
import InputBase from '../InputBase';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "input": "InputPassword-input_1bcHB",
  "addon": "InputPassword-addon_2vnSh",
  "icon": "InputPassword-icon_1pnAq"
};
class InputPassword extends React.Component {
  static defaultProps = {
    visibilityTimeout: 5550,
    classes: {}
  };
  state = (() => ({
    visible: this.props.visible || false,
    focused: false
  }))();
  UNSAFE_componentWillReceiveProps({
    visible
  }) {
    if (typeof visible === 'boolean' && visible !== this.state.visible) {
      this.toggleVisibility();
    }
  }
  classOf(name) {
    return this.props.classes[name] || '';
  }
  handleFocus = evt => {
    if (this.state.focused === false) {
      this.setState({
        focused: true
      });
    }
    if (this.props.handleFocus) {
      this.props.handleFocus(evt);
    }
  };
  handleBlur = evt => {
    if (isNode(evt.relatedTarget) && evt.relatedTarget.contains(this.addon)) {
      return;
    }
    this.setState({
      focused: false
    });
    if (this.props.handleBlur) {
      this.props.handleBlur(evt);
    }
  };
  toggleVisibility = () => {
    if (this.visibilityTimeoutID) {
      clearTimeout(this.visibilityTimeoutID);
    }
    this.setState(prevState => ({
      visible: !prevState.visible
    }), () => {
      if (this.state.visible) {
        this.visibilityTimeoutID = setTimeout(this.toggleVisibility, this.props.visibilityTimeout);
      }
    });
  };
  handleAddonClick = () => {
    if (isNode(this.input)) {
      this.input.focus();
    }
    this.toggleVisibility();
  };
  getInputRef = node => {
    this.input = node;
  };
  getAddonRef = node => {
    this.addon = node;
  };
  render() {
    const {
      id,
      name,
      value,
      defaultValue,
      visibilityTimeout,
      visible,
      block,
      classes,
      autoComplete,
      autoFocus,
      required,
      handleChange,
      handleKeyDown,
      handleFocus,
      handleBlur,
      ...extraProps
    } = this.props;
    const inputClasses = clsx(styles.input, this.classOf('input'));
    const addonClasses = clsx(styles.addon, this.classOf('addon'));
    return /*#__PURE__*/_jsxs(Base, {
      flex: block,
      flexInline: !block,
      ...extraProps,
      children: [/*#__PURE__*/_jsx(InputBase, {
        id: id || name,
        name: name,
        type: this.state.visible ? 'text' : 'password',
        tagName: "input",
        flexGrow1: block,
        value: value,
        defaultValue: defaultValue,
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        roundedTopLeft: true,
        roundedBottomLeft: true,
        borderedLeft: true,
        className: inputClasses,
        refCallback: this.getInputRef,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        required: required
      }), /*#__PURE__*/_jsx(Addon, {
        visible: this.state.visible,
        focused: this.state.focused,
        onClick: this.handleAddonClick,
        className: addonClasses,
        refCallback: this.getAddonRef
      })]
    });
  }
}
function Addon({
  visible,
  ...extraProps
}) {
  const {
    __
  } = useTranslator();
  const label = visible ? __('Hide password') : __('Show password');
  return /*#__PURE__*/_jsxs(InputAddon, {
    tabIndex: "-1",
    tagName: "button",
    type: "button",
    title: label,
    flex: true,
    flexShrink0: true,
    placeItemsCenter: true,
    roundedTopRight: true,
    roundedBottomRight: true,
    borderedRight: true,
    withIcon: true,
    padded: true,
    ...extraProps,
    children: [/*#__PURE__*/_jsx(Svg, {
      name: visible ? 'eyeCrossed' : 'eye',
      theme: "neutral-strong",
      className: styles.icon
    }), /*#__PURE__*/_jsx(SrOnly, {
      children: label
    })]
  });
}
export default InputPassword;